<template>
	<BaseThemeUiModal v-slot="{onClose, active}" name="shareemail" :key-closable="true">
		<div v-if="active" class="modal">
			<div style="position: relative; pointer-events: all;">
				<div class="modal-close" @click="onClose()" />
				<div class="modal-cnt">
					<BaseCmsShareEmailForm class="base-modal-share-email-form form-animated-label" v-slot="{fields, status, loading}">
						<BaseCmsLabel :class="[{'global-success': status?.success}, {'global-error': !status?.success}]" v-if="status" tag="div" :code="(status?.data?.label_name == 'succes_ok') ? 'tellafriend_thankyou' : 'tellafriend_' + status?.data?.label_name" />
						<template v-if="!status?.success">
							<template v-for="field in fields" :key="field.name">
								<BaseFormField :item="field" v-slot="{errorMessage, floatingLabel}">
									<p class="field" :class="['field-' + field.name, {'ffl-floated': floatingLabel}]">
										<BaseFormInput :id="'share-'+field.name" />
										<BaseCmsLabel :code="field.name" tag="label" :for="'share-'+field.name" />
										<span class="error" v-show="errorMessage" v-html="errorMessage" />
									</p>
								</BaseFormField>
							</template>
							<div class="base-modal-share-email-btns">
								<button :disabled="loading" :class="{'loading': loading}" class="base-modal-share-email-submit" type="submit">
									<span class="loader" v-show="loading" />
									<BaseCmsLabel code="send" />
								</button>
							</div>
						</template>
					</BaseCmsShareEmailForm>
				</div>
			</div>
			<div class="modal-mask" @click="onClose()" />
		</div>
	</BaseThemeUiModal>
</template>

<script setup>
	const labels = useLabels();
</script>

<style scoped lang="less">
	body.modal-active {
		touch-action: none;
		-ms-scroll-chaining: none;
		overscroll-behavior: none;
		-webkit-overflow-scrolling: auto;
		overflow: hidden;
	}

	:deep(.global-success), :deep(.global-error){
		p{padding: 0;}
	}
	.modal{position: fixed; display: flex; align-items: center; justify-content: center; top: 0; right: 0; bottom: 0; left: 0; z-index: 9999; pointer-events: none;}
	.modal-mask{position: fixed; top: 0; right: 0; bottom: 0; left: 0; background-color: rgba(0,26,52,0.5); pointer-events: all; z-index: -1;}
	.modal-cnt{
		width: 600px; max-width: 100%; max-height: 85vh; margin: 0; padding: 30px 40px; background: #fff; box-shadow: 4px 0px 10px 5px rgba(0, 0, 0, 0.2); position: relative; z-index: 1; pointer-events: all;

		@media (max-width: @m){width: 90vw; max-height: 100vh; box-shadow: none; padding: 20px 15px;}
	}
	.modal-close{
		display: flex; align-items: center; justify-content: center; width: 44px; height: 44px; background: url(assets/images/close.svg) no-repeat; background-size: contain; position: absolute; right: -18px; top: -18px; cursor: pointer; z-index: 100;

		@media (max-width: @m){width: 35px; height: 35px;}
	}

	.base-modal-share-email-btns{
		margin-top: 10px;
		button{width: 100%;}
	}

	/* animations */
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.2s ease;
	}

	.fade-enter-from,
	.fade-leave-to {
		opacity: 0;
	}
</style>
